import React from 'react';
import PropTypes from 'prop-types';
import ConnectedThemeProvider from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/ThemeProvider';
import { merge } from 'lodash';
import { createTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { anthracite, darkBlue, darkGray, red } from '../Constants/Colors';

export const bodyFont = '"Open Sans", "Roboto", "Helvetica", "Arial", "sans-serif"';

const theme = createTheme({
  palette: {
    secondary: {
      main: darkBlue,
    },
  },
  typography: {
    fontFamily: bodyFont,
  },
  overrides: {
    MuiIconButton: {
      root: {
        color: 'white',
        fontSize: '1em',
      },
      label: {
        '& > span': {
          marginTop: '3px',
        },
      },
    },
    MuiSvgIcon: {
      root: {
        marginRight: '0.4em',
      },
    },
    MuiButton: {
      root: {
        backgroundColor: darkBlue,
        textTransform: 'uppercase',
        color: 'white',
        fontSize: '1.75em',
        borderRadius: 'none',
        borderBottom: `5px solid ${red}`,
        '&:hover': {
          backgroundColor: darkBlue,
        },
        '&.Mui-disabled': {
          backgroundColor: darkGray,
          color: anthracite,
          borderBottomColor: anthracite,
          opacity: 0.8,
        },
      },
      label: {
        padding: '5px 4rem 0 4rem',
        fontWeight: 'bold',
      },
    },
    MuiGrid: {
      container: {
        width: 'auto',
      },
    },
    MuiDialogActions: {
      root: {
        '& .MuiButtonBase-root': {
          backgroundColor: darkBlue,
        },
      },
    },
  },
});

const overrideTheme = (theme) => {
  merge(theme.overrides, {});
};

export default function ThemeProvider({ children }) {
  return (
    <ConnectedThemeProvider customTheme={theme} withTheme={overrideTheme}>
      <CssBaseline />
      {children}
    </ConnectedThemeProvider>
  );
}

ThemeProvider.propTypes = {
  children: PropTypes.node,
};
